import { useContext } from 'react'

import { AIReviewStatusContext } from '../context/AIReviewStatusContext'

export const useAIReviewStatusContext = () => {
    return useContext(AIReviewStatusContext);
}